import Vue from 'vue'
import App from './App.vue'
import Impedimento from './Impedimento.vue';
import vuetify from './plugins/vuetify';
import archivos from '@demre/client-common/src/plugins/archivos';
import router from './router'
import store from './store';
import graphql from './utils/graphql';
import auth from './plugins/authorized';
import validator from './utils/validator';

Vue.use(archivos);
Vue.use(auth);
Vue.config.productionTip = false;
Vue.use(validator);

async function init() {
  const query = {
    query: `
      query {
        locales: usuariosRoles {
          fspCodigo
          sedCodigo
          lapCodigo
          usuario
          local {
            nroLocal
            nombre
            reunionJefDel
            local {
              rbd
              comuna{
                comNombre
              }
              provincia {
                prvNombre
              }
              region {
                regNombre
              }
            }
            direccion
            fono
            fonoDos
            fonoTres
          }
          sede {
            sedCodigo
            sedNombre
            sadCodigo
            sad {
              sadNombre
              datosSecretarias {
                nombreSecretario
                direccionLaboral
                telefonoLaboralUno
                telefonoLaboralDos
              }
            }
          }
          fase {
            fspDescripcion
            fspTipo
          }
          rol {
            idRol
            nombre
          }
        }
        fases: fasePrueba {
          fspCodigo
          fspDescripcion
          vigente
          orden
          maximoDiasTrabajables
          rdnInvierno
          fspTipo
          fechaMarcaDelegado
        }
        modulos {
          idModulo
          fase {
            fspCodigo
          }
        }
      }
    `,
  };
  const { locales, fases, modulos } = await graphql.request(query);

  window.DATA = {
    locales,
    fases,
    modulos,
  };
}

store.dispatch('session/load')
  .then(init)
  .then(() => {
    new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })
  .catch(err => {
    const mensaje = err.message;
    new Vue({
      vuetify,
      router,
      store,
      render: h => h(Impedimento, {props: {mensaje}})
    }).$mount('#app')
  })

window.store = store;

